import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
import { ArbeitsplanType, Terminarten, UserType } from "../utils/types";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import moment from "moment";

// function Copyright() {
//   return (
//     <Typography variant="body2" color="text.secondary">
//       {"Copyright © "}
//       <Link color="inherit" href="#">
//         My Forum
//       </Link>{" "}
//       {new Date().getFullYear()}
//       {"."}
//     </Typography>
//   );
// }

const Footer = () => {
  // const [anchorElUser, setAnchorElUser] = React.useState(null);

  // let { user } = useContext(AuthContext);
  // let { logoutUser } = useContext(AuthContext);

  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };
  // const handleCloseUserMenu = () => {
  //   setAnchorElUser(null);
  // };
  const [arbeitsplan, setArbeitsplan] = React.useState<ArbeitsplanType>();
  React.useEffect(() => {
    const getArbeitsplan = async () => {
      const response = await fetch(`/api/getSingleArbeitsplan/`, {
        cache: "no-cache",
      });
      const data = await response.json();
      setArbeitsplan(data);
    };

    getArbeitsplan();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: "4vh",
      }}
    >
      <CssBaseline />

      <Box
        component="footer"
        className="footer"
        sx={{
          py: 2,
          px: 2,
          mt: "auto",
          backgroundColor: "#1d9538",
          height: "1vh",
          position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 10000,
        }}
      >
        {arbeitsplan && (
          <Typography
            variant="body2"
            color="white"
            align="center"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            Zuletzt aktualisiert:{" "}
            {moment(arbeitsplan.modifiedon).format("DD.MM.YYYY HH:mm")}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Footer;
